import {
  BlogPostImagesParams,
  BlogPostModel,
  BlogPostRequest,
} from '../types/blogPost';
import getGalleryImages from './getGalleryImages';

interface BlogPostData {
  post: BlogPostRequest;
  images: BlogPostImagesParams;
}

export const compileBlogPostRequest = (data: BlogPostRequest): BlogPostData => {
  let blogPost: BlogPostRequest = {
    // filesGallery: data.filesGallery,
    // filesGalleryMobile: data.filesGalleryMobile,
    // galleryImages: [],
    // galleryImagesMobile: [],
    previewImage: data.filesPreviewImage?.key || '',
    _id: data._id,
  };
  let images: BlogPostImagesParams = {
    previewImage: undefined,
    // galleryImages: [],
    // galleryImagesMobile: [],
  };

  // if (data.filesGallery) {
  //   images.galleryImages = getGalleryImages(data.filesGallery);
  // }
  // if (data.filesGalleryMobile) {
  //   images.galleryImagesMobile = getGalleryImages(data.filesGalleryMobile);
  // }

  if (data.filesPreviewImage) {
    images.previewImage = data.filesPreviewImage.rawFile;
  }

  const blogPostData: BlogPostData = {
    post: blogPost,
    images: images,
  };
  // blogPost.galleryImages = [];
  // blogPost.galleryImagesMobile = [];
  return blogPostData;
};
